// import "statgrab/do"

////////////
// Frame //
//////////

import frem from "frem"
import sizes from "@frog/source/data/sizes.js"

frem({
    "width": sizes.frame.width,
    "height": sizes.frame.height,
})

////////////////
// Analytics //
//////////////

import "@frog/source/analytics.js"

////////////////////////
// Performance Stats //
//////////////////////

// import Stats from "stats.js"
// const stats = new Stats()
// stats.dom.style.position = "absolute"
// stats.dom.style.display = "flex"
// stats.dom.style.zIndex = -1
// Object.values(stats.dom.children).forEach((child) => child.style = "block")
// stats.dom.addEventListener("click", (event) => event.stopPropagation(), true)
// document.body.appendChild(stats.dom)
// // document.getElementById("frame").appendChild(stats.dom)

////////////////
// Main Loop //
//////////////

import * as Preact from "preact"
import Yaafloop from "yaafloop"

import View from "@frog/source/views/Mount.view.js"
import Index from "@frog/source/models/App.js"

let loop = new Yaafloop(function(delta) {
    // stats.begin()
    Index.update(delta)
    this.view = Preact.render(Preact.h(View), document.body, this.view)
    // stats.end()
})

// import "@frog/source/views/Mount.view.less"
// import DevBar from "@frog/source/views/DevBar.view.js"
//
// let loop = new Yaafloop(function(delta) {
//     this.view = Preact.render(Preact.h(DevBar), document.body, this.view)
// })

//////////////
// Testing //
////////////

import Sleep from "@frog/source/utility/Sleep.js"

if(__STAGE__ == "DEVELOPMENT") {
    // import(/* webpackChunkName: "test.js" */"@frog/source/test.js")
    // import("@frog/source/utility/Testrecord.js")
    // Sleep(20 * 1000).then(() => import(/* webpackChunkName: "test.js" */"@frog/source/test.js"))
    // Sleep(2 * 1000).then(() => import(/* webpackChunkName: "test.js" */"@frog/source/test.js"))
    // require("@frog/source/test.js")
    // Sleep(1000).then(() => import("@frog/source/test.js"))
    // import("@frog/source/test.js")
    // import(/* webpackChunkName: "test.js" */"@frog/source/test.js")
}
